// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3EWBq","overflowing":"ReadFullNote_overflowing__ERYWL"};